import React, { createContext, useState, useEffect, useContext } from 'react';
import { supabase } from '../Servicios/supabaseClient.js';

// 1. Crear el Contexto
const AuthContext = createContext();

// 2. Crear el Proveedor (AuthProvider)
// Este componente envolverá tu aplicación
export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true); // Para saber si estamos cargando la sesión inicial

  useEffect(() => {
    // 1. Obtener la sesión existente al cargar la app
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    // 2. Escuchar cambios en la autenticación (Login, Logout)
    // Esto es CLAVE: se dispara cuando el usuario hace login,
    // se registra, o hace logout.
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
        // Si acabamos de cargar, quitamos el loading
        if (loading) setLoading(false); 
      }
    );

    // Limpiar el listener al desmontar el componente
    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []); // El array vacío asegura que se ejecute solo una vez

  // El "value" es lo que nuestros componentes "hijos" podrán consumir
  const value = {
    session,
    user: session?.user, // El objeto 'user' o 'null'
    loading
  };

  // No renderizamos nada hasta saber si hay sesión o no
  // para evitar "parpadeos" (flickering)
  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

// 3. Crear un Hook personalizado para usar el contexto
// (Esto es una buena práctica para no importar 'useContext' y 'AuthContext' en todos lados)
export function useAuth() {
  return useContext(AuthContext);
}